// Utility to manage debug logging across the application

// Flag to enable/disable all debug logs
let DEBUG_ENABLED = true;

// Original console methods
const originalConsole = {
  log: console.log,
  debug: console.debug,
  info: console.info,
  warn: console.warn,
  error: console.error,
};

// Save reference to window object
const globalWindow = typeof window !== 'undefined' ? window : null;

/**
 * Enable or disable debug logging across the application
 * @param enabled Whether debug logging is enabled
 */
export function setDebugEnabled(enabled: boolean) {
  DEBUG_ENABLED = enabled;

  // LOG SEMPRE ABILITATI - Codice di sovrascrittura commentato
  // Non sovrascriviamo mai console per mantenere i log sempre visibili

  // Store in localStorage to persist across page refreshes
  if (globalWindow?.localStorage) {
    localStorage.setItem('debug_enabled', enabled ? 'true' : 'false');
  }

  // if (!enabled) {
  //   // Override console methods to suppress output
  //   console.log = (...args: any[]) => {};
  //   console.debug = (...args: any[]) => {};
  //   console.info = (...args: any[]) => {};
  //
  //   // Keep console.warn and console.error intact
  //   console.warn = originalConsole.warn;
  //   console.error = originalConsole.error;
  // } else {
  //   // Restore original console methods
  //   console.log = originalConsole.log;
  //   console.debug = originalConsole.debug;
  //   console.info = originalConsole.info;
  //   console.warn = originalConsole.warn;
  //   console.error = originalConsole.error;
  // }
}

/**
 * Check if debug logging is enabled
 */
export function isDebugEnabled() {
  return DEBUG_ENABLED;
}

/**
 * Initialize debug settings from localStorage
 */
export function initDebug() {
  // Check localStorage for debug setting
  if (globalWindow?.localStorage) {
    const debugSetting = localStorage.getItem('debug_enabled');
    // Se non c'è in localStorage, abilita di default
    setDebugEnabled(debugSetting !== 'false');
  } else {
    // Default abilitato
    setDebugEnabled(true);
  }
}

// Add a global method to toggle debug (for use in the console)
if (globalWindow) {
  (window as any).toggleDebug = function() {
    setDebugEnabled(!DEBUG_ENABLED);
    console.warn(`⚠️ Debug logging ${DEBUG_ENABLED ? 'enabled' : 'disabled'} - MA I LOG SONO SEMPRE ATTIVI`);
    return `Debug logging ${DEBUG_ENABLED ? 'enabled' : 'disabled'} (logs always visible)`;
  };
}

// Filter sanitize-html warnings and Realtime timeouts
if (globalWindow) {
  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = function(...args: any[]) {
    // Ignora warning di esternalizzazione moduli (sanitize-html)
    const message = args[0];
    if (typeof message === 'string') {
      if (message.includes('Module') && message.includes('externalized for browser compatibility')) {
        return; // Silenziosamente ignora
      }
      if (message.includes('Cannot access') && message.includes('in client code')) {
        return; // Silenziosamente ignora
      }
      // Ignora timeout Realtime (si riconnettono automaticamente)
      if (message.includes('[RealtimeService]') && message.includes('Timeout')) {
        return; // Silenziosamente ignora
      }
      if (message.includes('[RealtimeService]') && message.includes('Errore canale')) {
        return; // Silenziosamente ignora
      }
    }
    originalError.apply(console, args);
  };

  console.warn = function(...args: any[]) {
    const message = args[0];
    if (typeof message === 'string') {
      // Ignora warning Realtime
      if (message.includes('[RealtimeService]') && message.includes('Connection closed')) {
        return; // Silenziosamente ignora
      }
    }
    originalWarn.apply(console, args);
  };
}

// Initialize when this module is imported
initDebug();